import { useCallback, useMemo } from 'react';

import { WorkspaceMapping } from '@/modules/lyearn-connect/components/ShareDialog/types';
import useShareDialogSubmit from '@/modules/lyearn-connect/components/ShareDialog/useShareDialogSubmit';
import { EventUnion, ShareConfigStatusEnum, SharedItemTypeEnum } from '@/types/schema';

export default function useShareSession({
  event,
  onClose,
}: {
  event: EventUnion;
  onClose: () => void;
}) {
  const alreadySharedConnections = useMemo(
    () =>
      event.shareConfigs
        ?.filter((item) => item.status === ShareConfigStatusEnum.Sent)
        .map((item) => item.workspaceId),
    [event.shareConfigs],
  );
  const { onSubmit, sharedItemsFetching } = useShareDialogSubmit();

  const _onSubmit = useCallback(
    (selectedWorkspaceMappings: WorkspaceMapping[], allowDuplication: boolean) => {
      onSubmit({
        itemId: event.id,
        type: SharedItemTypeEnum.Session,
        selectedWorkspaceMappings,
        allowDuplication,
      });
      onClose();
    },
    [event.id, onClose, onSubmit],
  );

  return {
    onSubmit: _onSubmit,
    alreadySharedConnections,
    fetching: sharedItemsFetching,
  };
}
